import gql from "graphql-tag";

export const q_GetPaymentStatus = gql`
  query GetPaymentStatus($input: GetPaymentStatusInput!) {
    GetPaymentStatus(input: $input) {
      valid
    }
  }
`;
